enum OrderSourceEnum {
    "ORDERWERKS" = 1,
    "WOOCOMMERCE",
    "SHOPIFY",
    "SHOPIFY_PLUS",
    "AMAZON",
    "3DCART",
    "PRESTASHOP",
    "MAGENTO",
    "VOLUSION",
    "WEEBLY",
    "SQUARESPACE",
    "WIX",
    "BIG_CARTEL",
    "SALESFORCE_B2C",
    "SALESFORCE_B2B",
    "EBAY",
    "ETSY",
    "BIGCOMMERCE",
    "OPENCART",
    "OTHER",
    "APP",
    "WAYFAIR",
    "ORDERWERKS_CART",
    "QUICKBOOKS_DESKTOP",
    "CATCHWERKS",
}

export default OrderSourceEnum;
